import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  IconButton,
  TextField,
  Collapse,
  TablePagination,
  Grid,
  Button,Box,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import CardHeadMenu from "../../Card/CardHeadMenu/CardHeadMenu";
import configServ from "../../../services/config";
import { useSelector } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import exportToExcel from "../../Download/DownloadInvoiceCancel";
import LoaderNew from "../../Loader/LoaderNew";
const InvoiceCancelReportTable = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [expandedRows, setExpandedRows] = useState([]);
  const { company_id, companyName } = useSelector(
    (state) => state.GlobalVariables
  );

  // Fetch data from API
  const fetchData = async (query = "") => {
    try {
      setLoading(true);
      const result = await configServ.getDeletedInvoices({
        company_id: company_id,
        invoice_number: query, // Send search query to the backend
      });
      if (result.success) {
        setData(result.data);
        setFilteredData(result.data);
      }
    }catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Handle Search
  const handleSearch = async (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    await fetchData(query); // Fetch filtered data from backend
  };

  // Handle Row Expansion
  const toggleRowExpansion = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  // Pagination
  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  const paginatedData = filteredData.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Invoice Cancel Report"}
        showCreate={false}
      />
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        className="px-4 py-2"
      >
        <Grid
          item
          xs={12}
          md={6}
          container
          alignItems="center"
          // justifyContent="space-between"
          gap={2}
        >
          <Typography variant="h6">
            Total Canceled Invoices: {filteredData.length}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            onClick={() => exportToExcel(filteredData, companyName)} // Ensure this function is implemented
          >
            Excel
          </Button>
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            label="Search by Invoice Number"
            variant="outlined"
            size="small"
            fullWidth
            value={searchQuery}
            onChange={handleSearch}
            InputProps={{
              endAdornment: searchQuery && (
                <IconButton
                  onClick={() => {
                    setSearchQuery("");
                    fetchData(""); // Reset the data by fetching without a query
                  }}
                >
                  ✖️
                </IconButton>
              ),
            }}
          />
        </Grid>
      </Grid>

      <TableContainer
        component={Paper}
        className="rounded-lg shadow-md"
        sx={{ display: { xs: "none", lg: "block" } }}
      >
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#4cb5f5" }}>
              <TableCell style={{ color: "white" }}>S.No</TableCell>
              <TableCell style={{ color: "white" }}>Invoice Number</TableCell>
              <TableCell style={{ color: "white" }}>Party Name</TableCell>
              <TableCell style={{ color: "white" }}>Invoice Date</TableCell>
              <TableCell style={{ color: "white" }}>Total Amount</TableCell>
              <TableCell style={{ color: "white" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <LoaderNew />
                </TableCell>
              </TableRow>
            ) : filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            ) : (
              paginatedData.map((invoice, index) => (
                <React.Fragment key={invoice.id}>
                  <TableRow
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                    }}
                  >
                    <TableCell>
                      {index + 1 + currentPage * rowsPerPage}
                    </TableCell>
                    <TableCell>{invoice.invoice_number}</TableCell>
                    <TableCell>{invoice.partyname}</TableCell>
                    <TableCell>{invoice.date}</TableCell>
                    <TableCell>{invoice.total_amount}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => toggleRowExpansion(invoice.id)}
                        size="small"
                      >
                        {expandedRows.includes(invoice.id) ? (
                          <KeyboardArrowUp />
                        ) : (
                          <AddIcon />
                        )}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      style={{ paddingBottom: 0, paddingTop: 0 }}
                    >
                      <Collapse
                        in={expandedRows.includes(invoice.id)}
                        timeout="auto"
                        unmountOnExit
                      >
                        <div className="p-4">
                          <Typography variant="subtitle1">
                            Invoice Items:
                          </Typography>
                          <Table size="small">
                            <TableHead>
                              <TableRow style={{ backgroundColor: "#4cb5f5" }}>
                                <TableCell style={{ color: "white" }}>
                                  S.No.
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Item Name
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Quantity
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Rate
                                </TableCell>
                                <TableCell style={{ color: "white" }}>
                                  Amount
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {invoice.items.map((item, index) => (
                                <TableRow
                                  key={item.id}
                                  style={{
                                    backgroundColor:
                                      index % 2 === 0 ? "#f9f9f9" : "#ffffff",
                                  }}
                                >
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{item.itemname}</TableCell>
                                  <TableCell>{item.qty}</TableCell>
                                  <TableCell>{item.rate}</TableCell>
                                  <TableCell>{item.amount}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </div>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box
        sx={{
          display: { xs: "flex", lg: "none" },
          flexDirection: "column",
          gap: 2,
        }}
      >
        {loading ? (
          <LoaderNew />
        ) : filteredData.length === 0 ? (
          <Typography align="center">No Data Found</Typography>
        ) : (
          paginatedData.map((invoice, index) => (
            <Paper
              key={invoice.id}
              elevation={3}
              sx={{ p: 2, borderRadius: 2 }}
            >
              <Typography variant="subtitle1">
                <strong>Invoice No:</strong> {invoice.invoice_number}
              </Typography>
              <Typography>
                <strong>Party:</strong> {invoice.partyname}
              </Typography>
              <Typography>
                <strong>Date:</strong> {invoice.date}
              </Typography>
              <Typography>
                <strong>Total:</strong> {invoice.total_amount}
              </Typography>
              <Box display="flex" justifyContent="flex-end">
                <IconButton
                  onClick={() => toggleRowExpansion(invoice.id)}
                  size="small"
                >
                  {expandedRows.includes(invoice.id) ? (
                    <KeyboardArrowUp />
                  ) : (
                    <AddIcon />
                  )}
                </IconButton>
              </Box>
              <Collapse
                in={expandedRows.includes(invoice.id)}
                timeout="auto"
                unmountOnExit
              >
                <Box sx={{ mt: 2 }}>
                  <Typography variant="subtitle1">Invoice Items:</Typography>
                  {invoice.items.map((item, i) => (
                    <Paper
                      key={item.id}
                      sx={{
                        p: 1,
                        mt: 1,
                        backgroundColor: i % 2 === 0 ? "#f9f9f9" : "#ffffff",
                      }}
                    >
                      <Typography>
                        <strong>Item:</strong> {item.itemname}
                      </Typography>
                      <Typography>
                        <strong>Qty:</strong> {item.qty}
                      </Typography>
                      <Typography>
                        <strong>Rate:</strong> {item.rate}
                      </Typography>
                      <Typography>
                        <strong>Amount:</strong> {item.amount}
                      </Typography>
                    </Paper>
                  ))}
                </Box>
              </Collapse>
            </Paper>
          ))
        )}
      </Box>

      <TablePagination
        rowsPerPageOptions={[20, 50, 100, 200, 500]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default InvoiceCancelReportTable;
